var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.filter.visible
    ? _c(
        "div",
        {
          staticClass: "accordion-panel filter-item",
          class: { filterTs: _vm.brandName === _vm.Brand.Travelsphere },
        },
        [
          _c(
            "h2",
            {
              staticClass:
                "accordion-panel__heading js-accordion-trigger filter-item__title",
              class: {
                "accordion-panel__buttonTs":
                  _vm.brandName === _vm.Brand.Travelsphere,
              },
            },
            [_vm._v(_vm._s(_vm.filter.label))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "accordion-panel__content js-accordion-target filter-item__options",
            },
            [
              _c(
                "ul",
                { staticClass: "filter-list" },
                _vm._l(_vm.filter.children, function (item, itemKey) {
                  return _c(
                    "li",
                    { key: itemKey, staticClass: "filter-list__item" },
                    [
                      _c("label", [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: { checked: item.selected },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFilterValue(
                                _vm.filterKey,
                                itemKey,
                                $event
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "filter-list__label" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.label) +
                              "\n            "
                          ),
                          _c("span", { staticClass: "filter-list__count" }, [
                            _vm._v("(" + _vm._s(item.count) + ")"),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }